import { getTypeByText, ReferenceConfig } from "@/plugins/extensions/Reference"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"

import FileList from "./File/FileList.vue"

export default {
  char: ReferenceConfig[ReferenceType.TIP].char,
  items: async ({ query }) => {
    const type = getTypeByText(
      `${ReferenceConfig[ReferenceType.TIP].char}${query}`
    ) as ReferenceType
    let component
    if (type === ReferenceType.FILE_LINK || type === ReferenceType.FILE) {
      component = FileList
    }
    return {
      query,
      component
    }
  }
}
